import { Base_Dispatcher } from '../Base/Base.Dispatcher'
import { Loca_SET_LOCATIONS } from './Loca.constants'
import { Loca_getLocationsByDistance } from './Loca.getLocationsByDistance'
import { Logg_event } from '../Logg/Logg.event'

export async function Loca_getLocations() {
    Logg_event('Start', { label: 'location.getLocations' })

    const locations = await Loca_getLocationsByDistance()

    Base_Dispatcher.dispatch({
        actionType: Loca_SET_LOCATIONS,
        data: locations,
    })
}
